import React from "react";
import { Result } from "antd";
import { useTranslation } from "react-i18next";

const ProductOfferNotFound = () => {
  const { t } = useTranslation();
  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", paddingTop: 25 }}>
        <img className="img-fluid" src={"/img/logo-white.png"} alt="" />
      </div>
      <Result status="404" title="Oops!" subTitle={t("productOfferNotFound.subTitle")} />
    </>
  );
};

export default ProductOfferNotFound;
